import { Component, OnInit, Input } from '@angular/core';
import { Field } from '@ngx-formly/core';
import { StageSandbox } from '../../services/stage.sandbox';
import { Subscription, Observable } from 'rxjs/Rx';

@Component({
  selector: 'tr-file-checkbox',
  templateUrl: './file-checkbox.component.html',
  styleUrls: ['./file-checkbox.component.scss']
})

export class FileCheckboxComponent extends Field {

  @Input() description: string;
  @Input() duedate: string;
  @Input() taskstatus: number;
  @Input() gototask: Object;

  private currentAction: string = '';
  private subscriptions: Array<Subscription> = [];

  constructor (private sb: StageSandbox) {
    super();

  }

  getFile(questionIndex: number) {
    // remove some html tags by using originalLabel
    this.subscriptions.push(
      this.sb.simpleDownload(this.to.href, this.to.fid, this.to.originalLabel)
    );
  }

  getType() {
    return 'checkbox';
  }

}



// WEBPACK FOOTER //
// ./src/app/stage/components/file-checkbox/file-checkbox.component.ts